import { Text } from '@lumapps/wrex-core/slate';

import { INLINE_AUTOCOMPLETE_SEARCH } from '../constants';

export const isAutocompleteSearch = (n: any): n is Text & { [INLINE_AUTOCOMPLETE_SEARCH]: true } =>
    Text.isText(n) && (n as any)[INLINE_AUTOCOMPLETE_SEARCH];
